module.exports = __webpack_public_path__ + "img/logo__volvo2.6f0d4de6.svg";